import { LotacaoView } from './_lotacaoModels'

/**
 * Texto de uma lotação para seletor e exibição: "Unidade · CBO 225125 - Médico clínico · INE 123".
 * Partes ausentes ficam de fora; sem lotação, devolve string vazia.
 */
export const descreveLotacao = (lotacao?: Pick<LotacaoView, 'unidade' | 'cbo' | 'ine'>): string =>
  lotacao
    ? [
        lotacao.unidade?.nome,
        lotacao.cbo &&
          `CBO ${lotacao.cbo.codigo}${lotacao.cbo.nome ? ` - ${lotacao.cbo.nome}` : ''}`,
        lotacao.ine && `INE ${lotacao.ine}`,
      ]
        .filter(Boolean)
        .join(' · ')
    : ''
